import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const EnablePluginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnablePlugin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pluginId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enablePlugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"boardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pluginId"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"EnablePlugin","document":EnablePluginDocument}} as const;
export type EnablePluginMutationVariables = Types.Exact<{
  boardId: Types.Scalars['ID']['input'];
  pluginId: Types.Scalars['ID']['input'];
  traceId: Types.Scalars['String']['input'];
}>;


export type EnablePluginMutation = (
  { __typename: 'Mutation' }
  & { enablePlugin?: Types.Maybe<(
    { __typename: 'Plugin_EnableResponse' }
    & Pick<Types.Plugin_EnableResponse, 'error' | 'success'>
  )> }
);

export type EnablePluginMutationFn = Apollo.MutationFunction<
  EnablePluginMutation,
  EnablePluginMutationVariables
>;

/**
 * __useEnablePluginMutation__
 *
 * To run a mutation, you first call `useEnablePluginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnablePluginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enablePluginMutation, { data, loading, error }] = useEnablePluginMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      pluginId: // value for 'pluginId'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useEnablePluginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnablePluginMutation,
    EnablePluginMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EnablePluginMutation,
    EnablePluginMutationVariables
  >(EnablePluginDocument, options);
}
export type EnablePluginMutationHookResult = ReturnType<
  typeof useEnablePluginMutation
>;
export type EnablePluginMutationResult =
  Apollo.MutationResult<EnablePluginMutation>;
export type EnablePluginMutationOptions = Apollo.BaseMutationOptions<
  EnablePluginMutation,
  EnablePluginMutationVariables
>;
